import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects'
import axios from 'axios'
import {
  acceptAction,
  rejectAction,
} from '@Infowijs-eng/component-library/modules/reduxPromiseHelpers'
import { debounceAction } from '@Infowijs-eng/component-library/modules/authentication'
import { serviceEndpoints } from '@Infowijs-eng/component-library/modules'
import actionTypes from '../../action-types'
import setUser from '../../actions/user/setUser'
import awaitAccessToken from '../../modules/awaitAccessToken'
import fetchUser from '../../actions/user/fetchUser'

const onFetchUser = function* onFetchUser() {
  yield takeLatest(actionTypes.USER.FETCH, function* onFetchUserSaga(action) {
    const accessToken = yield call(awaitAccessToken)

    let response
    const {
      payload: { id },
      meta: { additionalInclude },
    } = action

    try {
      response = yield call(axios, {
        url: `${serviceEndpoints.users}/${id}`,
        params: {
          include: ['customer', 'lastUpdatedBy', 'userRole', ...(additionalInclude || [])].join(','),
        },
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/vnd.infowijs.v1+json',
          Accept: 'application/vnd.infowijs.v1+json',
          'X-Infowijs-Client': 'nl.infowijs.admin',
        },
      })
    } catch (e) {
      if (e.response.status === 401) {
        yield debounceAction(function* reFetchUser() {
          yield put(fetchUser(id))
        })
      }

      rejectAction(action, e.response.data && e.response.data.errors)
      return
    }

    yield put(setUser(response.data.data, response.data.included))

    acceptAction(action, response.data.data)
  })
}

export default onFetchUser
